import { get } from "@/helpers";

export const getShippingFee = shippingMethod => {
  let fee = 0;
  switch (shippingMethod.price_type) {
    case "flat-rate":
      fee = get(shippingMethod, "mainPrice.value", 0);
      break;

    case "country":
      // TODO
      break;

    // TODO
    // process other price types
  }
  return fee;
};
